/** @format */

import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../context/DataContext";

import ObligacionesApagar from "./Obligaciones-apagar";
import ObligacionesPagadas from "./Obligaciones-pagadas";
import Footer from "../components/Footer";

import Apagar from "../assets/img/cash.svg";
import Sincronizar from "../assets/img/intercambio.svg";
import Pagadas from "../assets/img/Cancelado.svg";

/* Begin By Javi */
import Header from "./Header";
import alertify from "alertifyjs";
import Grid from "./Movil/Grid-m";
import utils from "./../util";
import { Loader } from "../util/loader";
import { getStorage, getStorageList } from "../util/auth";
import { apiPagos } from "../api";
/* End By Javi */

let codigo = 0;
const { isMobile } = utils;
export const Pagos = () => {
  /* Begin By Javi */
  const [Loading, setloading] = useState(true);
  const [alertMessage, setMessage] = useState("Notificación de Pagos");
  const [_isMobile] = useState(isMobile());
  let dataStorage = getStorage("studientActive");
  let dataListStorage = getStorageList("studientList");
  /* End By Javi */
  const { data, setData } = useContext(DataContext);

  const [finacesDebts, setFinancesDebts] = useState([]);
  const [financesVisaSync, setFinancesVisaSync] = useState([]);
  const [finacesPaid, setFinancesPaid] = useState([]);
  const [tabActivoValue, setTabActivoValue] = useState("OBLIGACIONES_A_PAGAR");

  const getFinancesDebts = () => {
    setloading(true);
    setTabActivoValue("OBLIGACIONES_A_PAGAR");
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    const promise = apiPagos.listarDebts(codigo, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setFinancesDebts(res);
      }
    });
  };

  const getFinancesVisaSync = () => {
    setloading(true);
    setTabActivoValue("PAGOS_POR_SINCRONIZAR");
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    const promise = apiPagos.listarVisaSync(codigo, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setFinancesVisaSync(res);
      }
    });
  };

  const getFinancesPaid = () => {
    setloading(true);
    setTabActivoValue("OBLIGACIONES_PAGADAS");
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    const promise = apiPagos.listarPaid(codigo, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setFinancesPaid(res);
      }
    });
  };

  useEffect(
    () => {
      setData({ ...data, students: dataListStorage, student: dataStorage });
      if (
        dataStorage.Codigo == undefined ||
        (data == undefined && dataListStorage.length != 1)
      ) {
        setloading(false);
        alertify
          .alert("Debe seleccionar un Estudiante", function () {
            window.location.href = "./home";
          })
          .setHeader(alertMessage);
        return;
      }

      getFinancesDebts();
    },
    [setData],
    [setFinancesVisaSync]
  );
  const ActiveAlummno = () => {
    if (tabActivoValue == "OBLIGACIONES_A_PAGAR") {
      getFinancesDebts();
    } else if (tabActivoValue == "PAGOS_POR_SINCRONIZAR") {
      getFinancesVisaSync();
    } else if (tabActivoValue == "OBLIGACIONES_PAGADAS") {
      getFinancesPaid();
    }
  };

  return (
    <div>
      {Loader(Loading)}
      {_isMobile ? (
        <>
          <div className="contend">
            <div className="text col-12 ">
              {data != undefined && data.student != undefined ? (
                <Header
                  objData={data}
                  Title={"Pagos"}
                  isMobile={_isMobile}
                  objActiveAlummno={ActiveAlummno}
                />
              ) : (
                ""
              )}
              <Grid
                Active={"Pagos"}
                objgetFinancesPaid={getFinancesPaid}
                objgetFinancesVisaSync={getFinancesVisaSync}
                objgetFinancesDebts={getFinancesDebts}
                ObjtabActivoValue={tabActivoValue}
                objFinacesDebts={finacesDebts}
                objFinacesPaid={finacesPaid}
                objhistorial={false}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="contend ">
            <div className="text col-12 ">
              <Header
                objData={data}
                Title={"Pagos"}
                objActiveAlummno={ActiveAlummno}
              />
              <div className="mt-4">
                <div className="mt-4">
                  <table className="table border-nav">
                    <thead className="">
                      <tr>
                        <th
                          scope="col-2"
                          className={
                            tabActivoValue == "OBLIGACIONES_A_PAGAR"
                              ? "text-card cont-nav background-cursos"
                              : "text-card cont-nav"
                          }
                          onClick={() => getFinancesDebts()}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={Apagar}
                            style={{ width: "32.99px", height: "32.99px" }}
                            className="mr-2"
                          />
                          OBLIGACIONES A PAGAR
                        </th>
                        <th
                          scope="col-2"
                          className={
                            tabActivoValue == "PAGOS_POR_SINCRONIZAR"
                              ? "text-card cont-nav background-cursos"
                              : "text-card cont-nav"
                          }
                          onClick={() => getFinancesVisaSync()}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={Sincronizar} className="mr-2" />
                          PAGOS POR SINCRONIZAR
                        </th>
                        <th
                          scope="col-2"
                          className={
                            tabActivoValue == "OBLIGACIONES_PAGADAS"
                              ? "text-card cont-nav background-cursos"
                              : "text-card cont-nav"
                          }
                          onClick={() => getFinancesPaid()}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={Pagadas} className="mr-2" />
                          OBLIGACIONES PAGADAS
                        </th>
                      </tr>
                    </thead>
                  </table>
                  {tabActivoValue == "OBLIGACIONES_A_PAGAR" ? (
                    <>
                      <div className="background-sub-cursos text-card head-apagar">
                        <div className=" columna-1">Tipo de Documento</div>
                        <div className=" columna-2">Número de Documento</div>
                        <div className=" columna-3">Fecha de Vencimiento</div>
                        <div className=" columna-4">Periodo</div>
                        <div className=" columna-5">Saldo</div>
                        <div className=" columna-6">Mora</div>
                        <div className="columna-7">Total a Pagar</div>
                        <div className="columna-8"></div>
                      </div>
                      {finacesDebts.length != 0 ? (
                        <ObligacionesApagar objFinacesDebts={finacesDebts} />
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          No existen Obligaciones a pagar...
                        </div>
                      )}
                    </>
                  ) : null}
                  {tabActivoValue == "OBLIGACIONES_PAGADAS" ? (
                    finacesDebts.length != 0 ? (
                      <ObligacionesPagadas objFinacesPaid={finacesPaid} />
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        No existen Obligaciones Pagadas...
                      </div>
                    )
                  ) : null}
                  {tabActivoValue == "PAGOS_POR_SINCRONIZAR" ? (
                    <div style={{ textAlign: "center", padding: "2% 0" }}>
                      No existen Pagos por Sincronizar...
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
